module.exports = __webpack_public_path__ + "static/media/autoshow.7f198ba6.png";